import { useEffect, useState } from "react";
import { AppModal } from '../';
import { TutorialModalControls } from "./TutorialModalControls";
import { StyledTutorialBg, StyledTutorialContent, StyledTutorialTitle, StyledTutorialWrapper } from "./TutorialModal.styled";
import { TutorialBasics } from "./turotials/TutorialBasics";
import { TutorialDash } from "./turotials/TutorialDash";
import { TutorialCombos } from "./turotials/TutorialCombos";
import { TutorialCombosAdvances } from "./turotials/TutorialCombosAdvances";
import { TutorialRangeWeapons } from "./turotials/TutorialRangeWeapons";
import { Achievement1Content } from "./custom-achievement-content/Achievement-1";
import { Achievement2Content } from "./custom-achievement-content/Achievement-2";
import { Achievement3Content } from "./custom-achievement-content/Achievement-3";
import { Achievement4Content } from "./custom-achievement-content/Achievement-4";
import useAppEvent from "../../hooks/useAppEvent";
import useModalSettings from "../../hooks/useModalSettings";
import { TutorialEnum } from "../../store/tutorialModal.store";


const TutorialModal = ({ tutorialId, onClose, earnings }) => {
  const { dispatchAppEvent } = useAppEvent('modalAction');
  const [step, setStep] = useState(0);
  const modalSettings = useModalSettings(tutorialId);
  
  const stepData = modalSettings.steps[step];

  const onBackStep = () => {
    setStep(step - 1);
  }

  const onNextStep = () => {
    if (typeof stepData.navigate !== 'undefined') {
      dispatchAppEvent({
        type: 'navigate',
        data: stepData.navigate
      });
    }

    if (step < modalSettings.steps.length - 1) {
      // Show next step
      setStep(step + 1);
    } else {
      // Close modal
      onClose();

      if (modalSettings.pauseGame) {
         dispatchAppEvent({
          type: 'pause',
          data: false
        });
      }
    }
  }

  useEffect(() => {
    // On first load check if we want to change navigation before 
    // modal first step display
    if (typeof modalSettings.prenavigate === 'number') {
      dispatchAppEvent({
        type: 'navigate',
        data: modalSettings.prenavigate
      });
    }

    if (modalSettings.pauseGame) {
      dispatchAppEvent({
        type: 'pause',
        data: true
      });
    }
  }, []);

  return (
    <AppModal>
        <StyledTutorialWrapper>
          <StyledTutorialBg>
            <img src='/assets/item_bg.png' />
          </StyledTutorialBg>
          <StyledTutorialContent>
            {modalSettings.title && <StyledTutorialTitle>{modalSettings.title}</StyledTutorialTitle>}
            
            {tutorialId === TutorialEnum.Basics && <TutorialBasics step={step} />}
            {tutorialId === TutorialEnum.Dash && <TutorialDash />}
            {tutorialId === TutorialEnum.Combos && <TutorialCombos />}
            {tutorialId === TutorialEnum.CombosAdvanced && <TutorialCombosAdvances />}
            {tutorialId === TutorialEnum.RangeWeapon && <TutorialRangeWeapons />}

            {tutorialId === 'achievement-1' && <Achievement1Content step={step} earnings={earnings} />}
            {tutorialId === 'achievement-2' && <Achievement2Content step={step} earnings={earnings} />}
            {tutorialId === 'achievement-3' && <Achievement3Content step={step} earnings={earnings} />}
            {tutorialId === 'achievement-4' && <Achievement4Content step={step} earnings={earnings} />}

            <TutorialModalControls
              step={step}
              nextButtonText={stepData.button}
              onNext={onNextStep}
              onBack={onBackStep}
            />
          </StyledTutorialContent>
        </StyledTutorialWrapper>
    </AppModal>
  );
};

export default TutorialModal;